if (!customElements.get('osft-variant-content')) {
  customElements.define(
    'osft-variant-content',
    class OsftVariantContent extends HTMLElement {
      connectedCallback() {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.section) return;
          const source = event.data.html.getElementById(this.id);
          if (!source) return;
          this.replaceChildren(...document.importNode(source, true).childNodes);
          this.hidden = source.hidden;
        });
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }
    }
  );
}
